/* eslint-disable */
import React, { PropTypes } from 'react';
import moment from 'moment';
import DenunciaForm from './DenunciaForm'
import  './css/detalharHistorico.css'
import $ from 'jquery';
import ConfigD from './util/ConfigD';

class DetalharDenuncia extends React.Component {

    constructor(props, context) {
        super(props, context);
        
        this.state = {

        };
    }


    render() {
        var denunciaForm = '';
        var elem = document.getElementById('linhaCard');
        elem.style = 'border-bottom-color: #8dd1e1 !important;'

        var denunciaForm = '';
        


        if($.isEmptyObject(this.props.historico.mHistoricoDenuncia)){
            return <div></div>
        }
    
        //console.log('historico - detalhar histórico ', this.props.historico)
        var quandoOnde = '';
          if (!$.isEmptyObject(this.props.historico.mHistoricoDenuncia.mQuandoOnde)){
            quandoOnde = (
                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12" >
                    <div>
                        <p>
                            <strong>Quando e onde o fato ocorreu? Você consegue dizer com precisão dia, horário e local? Informe também se continua ocorrendo:<br /></strong>
                        </p>
                    </div>
                    <div className="clearfix"></div>
                    <div><p>
                        {this.props.historico.mHistoricoDenuncia.mQuandoOnde}
                    </p></div>
                    <br />
                </div>
            )
          }

          var meioConhecimentoDescricao = '';
          if (!$.isEmptyObject(this.props.historico.mHistoricoDenuncia.mMeioConhecimentoDescricao)) {
            meioConhecimentoDescricao = (
                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12" >
                    <div>
                        <p>
                            <strong>Indique como você tomou conhecimento do ocorrido:<br /> </strong>
                        </p>
                    </div>
                    <div className="clearfix"></div>
                    <div><p>
                        {this.props.historico.mHistoricoDenuncia.mMeioConhecimentoDescricao}
                        </p>
                    </div>
                    <br />
                </div>
              )
          }

          var testemunha = '';
          if (!$.isEmptyObject( this.props.historico.mHistoricoDenuncia.mTestemunha)) {
              testemunha = (
                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12" >
                    <div>
                        <p>
                            <strong>Existem testemunhas que possam auxiliar na comprovação do fato? Se sim, cite até 3 (três) testemunhas.<br /> </strong>
                        </p>
                    </div>
                    <div className="clearfix"></div>
                    <div>
                        {this.props.historico.mHistoricoDenuncia.mTestemunha}
                    </div>
                    <br />
                </div>
              )
          }
    
          var valor = '';
          if (!$.isEmptyObject(this.props.historico.mHistoricoDenuncia.mValor)) {
              valor = (
                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12" >
                    <div>
                        <p>
                            <strong>Se for o caso, indique o valor financeiro envolvido no fato relatado:<br /> </strong>
                        </p>
                    </div>
                    <div className="clearfix"></div>
                    <div>
                        {this.props.historico.mHistoricoDenuncia.mValor}
                    </div>
                    <br />
                </div>
              )
          }

          var tempoConhecimento = '';
          if (!$.isEmptyObject(this.props.historico.mHistoricoDenuncia.mTempoConhecimento)) {
              tempoConhecimento = (
                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12" >
                    <div>
                        <p>
                            <strong>Há quanto tempo você tem conhecimento sobre o fato?<br /> </strong>
                        </p>
                    </div>
                    <div className="clearfix"></div>
                    <div>
                        {this.props.historico.mHistoricoDenuncia.mTempoConhecimento}
                    </div>
                    <br />
                </div>
              )
          }

          var documento = '';
          if (!$.isEmptyObject( this.props.historico.mHistoricoDenuncia.mDocumento)) {
                documento = (
                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12" >
                    <div>
                        <p>
                            <strong>Descreva evidências ou informações que você julgue relevantes para orientar / subsidiar a apuração dos fatos relatados. Como exemplo podem ser usadas fotos, gravações de reuniões, contratos, e-mail, mensagens de celular, gravações de câmeras de segurança. Especifique da forma mais detalhada possível:<br /> </strong>
                        </p>
                    </div>
                    <div className="clearfix"></div>
                    <div>
                        {this.props.historico.mHistoricoDenuncia.mDocumento}
                    </div>
                    <br />
                </div>
            )
          }

          var lideranca = '';
          if (!$.isEmptyObject(this.props.historico.mHistoricoDenuncia.mLideranca)) {
              lideranca = (
                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12" >
                    <div>
                        <p>
                            <strong>Alguma liderança do SEBRAE tem ciência do ocorrido?<br /> </strong>
                        </p>
                    </div>
                    <div className="clearfix"></div>
                    <div>
                        {this.props.historico.mHistoricoDenuncia.mLideranca}
                    </div>
                    <br />
                </div>
              )
          }          

          var ameaca = '';
          if (!$.isEmptyObject(this.props.historico.mHistoricoDenuncia.mAmeaca)) {
              ameaca = (
                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12" >
                    <div>
                        <p>
                            <strong>Você sofreu ou presenciou alguma ameaça direta ou indireta para evitar a denúncia desse fato?<br /> </strong>
                        </p>
                    </div>
                    <div className="clearfix"></div>
                    <div>
                        {this.props.historico.mHistoricoDenuncia.mAmeaca}
                    </div>
                    <br />
                </div>
              )
          }

          var evidencia = '';
          if (!$.isEmptyObject(this.props.historico.mHistoricoDenuncia.mEvidencia)) {
              evidencia = (
                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12" >
                    <div>
                        <p>
                            <strong>Descreva outras evidências ou informações que você julgue relevantes para orientar / subsidiar a apuração dos fatos relatados:<br /> </strong>
                        </p>
                    </div>
                    <div className="clearfix"></div>
                    <div>
                        {this.props.historico.mHistoricoDenuncia.mEvidencia}
                    </div>
                    <br />
                </div>
              )
          }


        return (
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12" >
            <br/>
                <div className="clearfix"></div>
                <h3 className="title">Detalhes da denúncia</h3>
                {quandoOnde}
                {testemunha}
                {valor}
                {ameaca}
                {meioConhecimentoDescricao}
                {documento}
                {tempoConhecimento}
                {lideranca}
                {evidencia}
            </div>
        );
    }
}


export default DetalharDenuncia;



/** WEBPACK FOOTER **
 ** ./src/components/DetalharDenuncia.js
 **/